document.documentElement.classList.add('js');
document.addEventListener('change',function(event){
  if(event.target.matches('[data-variant-select]')){
    var option=event.target.options[event.target.selectedIndex];
    var price=document.querySelector('[data-product-price]');
    if(price&&option.dataset.price) price.textContent=option.dataset.price;
    var sku=document.querySelector('[data-product-sku]');
    if(sku) sku.textContent=option.dataset.sku||'';
    var form=event.target.closest('form');
    var quantity=form&&form.querySelector('[data-quantity-selector] input[name="quantity"]');
    var submit=form&&form.querySelector('[data-product-submit]');
    var canAdd=option.dataset.canAdd!=='false';
    if(quantity){
      quantity.min=canAdd?(option.dataset.quantityMin||1):0;
      quantity.step=option.dataset.quantityStep||1;
      if(option.dataset.quantityMax) quantity.max=option.dataset.quantityMax;
      else quantity.removeAttribute('max');
      quantity.value=quantity.min;
      updateQuantityButtons(quantity.closest('[data-quantity-selector]'));
    }
    if(submit){
      submit.disabled=!canAdd;
      if(option.dataset.buttonLabel) submit.textContent=option.dataset.buttonLabel;
    }
  }
});

function updateQuantityButtons(selector){
  if(!selector) return;
  var input=selector.querySelector('[data-quantity-input]');
  var minus=selector.querySelector('[data-quantity-minus]');
  var plus=selector.querySelector('[data-quantity-plus]');
  if(!input) return;
  var value=Number(input.value)||Number(input.min)||1;
  var min=input.min!==''?Number(input.min):1;
  var max=input.max!==''?Number(input.max):Infinity;
  if(minus) minus.disabled=value<=min;
  if(plus) plus.disabled=value>=max;
}

document.addEventListener('click',function(event){
  var button=event.target.closest('[data-quantity-minus],[data-quantity-plus]');
  if(!button) return;
  var selector=button.closest('[data-quantity-selector]');
  var input=selector&&selector.querySelector('[data-quantity-input]');
  if(!input) return;
  if(button.hasAttribute('data-quantity-plus')) input.stepUp();
  else input.stepDown();
  input.dispatchEvent(new Event('change',{bubbles:true}));
});

document.addEventListener('change',function(event){
  if(event.target.matches('[data-quantity-input]')){
    var input=event.target;
    var min=input.min!==''?Number(input.min):1;
    var max=input.max!==''?Number(input.max):Infinity;
    var value=Number(input.value)||min;
    input.value=Math.min(Math.max(value,min),max);
    updateQuantityButtons(input.closest('[data-quantity-selector]'));
  }
});

document.querySelectorAll('[data-quantity-selector]').forEach(updateQuantityButtons);
